import { Button } from "@mui/material";
import React, { useMemo, useState } from "react";
import { MapContainer, Marker, TileLayer, useMapEvents, Polyline, useMap } from "react-leaflet";
import { Icon } from "leaflet";
import { isEmpty, isNil } from "ramda";
import palette, { polylineColors } from "../../../../../config/colorPalette";
import { MapTypeContent } from "../../../Home/components/Map/styled";
import MapTypeSelector from "../../../Home/components/MapTypeSelector";
import { toast } from "react-toastify";

const PolylineData = ({
  setPolyline,
  polylineDisplay,
  setPolylineDisplay,
  centroid,
  setCentroid,
  pIndexes,
  setPIndexes,
  equipmentCollection,
  equipment,
  setEquipment,
  badEquipmentList,
  setBadEquipmentList,
  intl,
}) => {
  const customIcon = new Icon({
    iconUrl: require("../../../../../images/Uptech-marker-icon.png"),
    iconSize: [50, 50],
    iconAnchor: [25, 50],
  });
  const [error, setError] = useState("");

  const normalizedPolylines = useMemo(() => {
    return (polylineDisplay ?? []).map((polyline) => ({
      ...polyline,
      points: (polyline.points ?? []).map((p) => ({
        lat: p.latitude,
        lng: p.longitude,
        pk: p.pk,
        id_fo_poss: p.id_fo_poss,
        z: p.z,
      })),
    }));
  }, [polylineDisplay]);

  const handleChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const reader = new FileReader();

      reader.onload = (e) => {
        let read;

        try {
          if (extension === "json") {
            const text = e.target.result;
            read = JSON.parse(text);
          } else if (extension === "csv") {
            read = parseCSVToJson(e.target.result);
          } else {
            throw new Error("unsupported.format");
          }
        } catch (err) {
          console.error(err);
          setError("bad.json");
          return;
        }

        if (!read || !read.polylines || !Array.isArray(read.polylines)) {
          setError("bad.structure");
          return;
        }

        try {
          const polylineTypes = new Set(read.polylines.map((p) => p.equipment_type));

          const equipmentSet = new Set(equipmentCollection);

          const notIn = [...polylineTypes].filter((type) => !equipmentSet.has(type));

          const extra = [...equipmentSet].filter((type) => !polylineTypes.has(type));

          setBadEquipmentList([notIn, extra]);

          if (isEmpty(extra) && isEmpty(notIn)) {
            const modifiedPolylines = read.polylines.map((polyline) => {
              const modifiedPoints = polyline.points.map((point) => {
                if (typeof point.latitude !== "number" || typeof point.longitude !== "number") {
                  throw new Error("bad.structure");
                }

                return {
                  ...point,
                  lat: point.latitude,
                  lng: point.longitude,
                };
              });

              return {
                ...polyline,
                points: modifiedPoints,
              };
            });

            setPolyline(read.polylines);
            setPolylineDisplay(modifiedPolylines);
            if (!isEmpty(equipment)) {
              setEquipment([]);
              toast.info(intl.formatMessage({ id: "equipment.deleted" }), { className: "toast-info" });
            }
            setError("");
          }
        } catch (error) {
          console.error(error);
          setError("bad.structure");
        }
      };

      reader.readAsText(file);
    }
  };

  function parseCSVToJson(csvContent) {
    const lines = csvContent.split("\n");
    const headers = lines[0]?.split(",");
    const jsonData = [];

    for (let i = 1; i < lines.length; i++) {
      const currentLine = lines[i].split(",");
      if (currentLine.length !== headers.length) {
        continue;
      }

      const entry = {};
      for (let j = 0; j < headers.length; j++) {
        entry[headers[j]] = currentLine[j];
      }
      jsonData.push(entry);
    }

    return jsonData;
  }

  const [mapType, setMapType] = useState("regular");

  const AddCentroid = () => {
    // eslint-disable-next-line no-unused-vars
    const map = useMapEvents({
      click: (e) => {
        setCentroid([e.latlng.lat, e.latlng.lng]);
      },
    });
    return null;
  };
  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points))
      map.fitBounds(polyline[0].points);
    return null;
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "1%" }}>
        <input type="file" accept=".csv, .json" style={{ display: "none" }} id="file-input" onChange={handleChange} />
        <label htmlFor="file-input">
          <Button variant="contained" component="span">
            Subir Archivo
          </Button>
        </label>
        <h3 style={{ color: "red", marginLeft: "1rem" }}>
          {isEmpty(centroid) && intl.formatMessage({ id: "add.centroid" })}
        </h3>
        <h3 style={{ color: "red", marginLeft: "1rem" }}>{error.length > 0 && intl.formatMessage({ id: error })}</h3>
        {!isNil(badEquipmentList[0]) && !isEmpty(badEquipmentList[0]) && (
          <h3 style={{ color: "red", marginLeft: "1rem" }}>
            {intl.formatMessage({ id: "are.missing" })}
            {": "}
            {badEquipmentList[0].join(", ")}
          </h3>
        )}
        {!isNil(badEquipmentList[1]) && !isEmpty(badEquipmentList[1]) && (
          <h3 style={{ color: "red", marginLeft: "1rem" }}>
            {intl.formatMessage({ id: "unnecessary" })}
            {": "}
            {badEquipmentList[1].join(", ")}
          </h3>
        )}
      </div>
      <MapContainer
        id="map-id"
        center={
          !isEmpty(normalizedPolylines) && normalizedPolylines[0]?.points.length > 0
            ? normalizedPolylines[0]?.points[Math.round(normalizedPolylines[0]?.points.length / 2)]
            : [27.337882, -27.919657]
        }
        zoom={!isEmpty(normalizedPolylines) && normalizedPolylines[0]?.points.length > 0 ? 10 : 3}
        style={{ height: "calc(100vh - 320px)", width: "165vh" }}
        anima
        rotateControl={false}
      >
        <TileLayer
          attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
          url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
          maxZoom={18}
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />
        <MyComponentSetView polyline={normalizedPolylines} />
        {normalizedPolylines.length > 0 &&
          // eslint-disable-next-line array-callback-return
          normalizedPolylines.map((polyline, index) => {
            // eslint-disable-next-line array-callback-return
            return polyline.points.map((point, indice) => {
              if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) {
                return null;
              }

              if (polyline.must_graph_points.includes(indice)) {
                const previousIndex = polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                const center = [
                  [
                    normalizedPolylines[index].points[previousIndex].lat,
                    normalizedPolylines[index].points[previousIndex].lng,
                  ],
                  [point.lat, point.lng],
                ];
                const color = normalizedPolylines.length > 10 ? "black" : polylineColors[index];
                return <Polyline key={indice + "_" + index} color={color} positions={center} weight={5}></Polyline>;
              }
            });
          })}
        <AddCentroid />
        {centroid.length > 0 && <Marker key={"Centroid"} position={centroid} icon={customIcon}></Marker>}

        {window.RUNTIME_CONFIG.IS_ONLINE ?? (
          <MapTypeContent>
            <MapTypeSelector items={window.RUNTIME_CONFIG.MAP_TYPES} onChange={setMapType} color={palette.dark} />
          </MapTypeContent>
        )}
      </MapContainer>
    </div>
  );
};
export default PolylineData;
